import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDStack } from '@facet-wealth/design';
import TransitionsDashboardPageSection
  from 'Views/Page/Content/Templates/TransitionsDashboardPage/TransitionsDashboardPage/TransitionsDashboardPageSection/TransitionsDashboardPageSection';

const TransitionsDashboardPageSections = ({ collection }) => {
  return (
    <FDStack spacing={2} direction={'row'} wrap>
      {collection.resources().list().map((resource) => (
        <FDBox key={resource.id()} flex={1}>
          <TransitionsDashboardPageSection resource={resource} />
        </FDBox>
      ))}
    </FDStack>
  );
};

TransitionsDashboardPageSections.propTypes = {
  collection: PropTypes.object.isRequired,
};

TransitionsDashboardPageSections.defaultProps = {};

export default TransitionsDashboardPageSections;
